module.exports = __webpack_public_path__ + "static/icon_card_sostenibilidad-1b8b2038d55b7275f2903f4164fdfa7e.png";